import {
  Button,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
} from "@chakra-ui/react";

export default function TourLayout({ children, onCloseTour }) {
  return (
    <Popover placement={"right"}>
      <PopoverTrigger>
        <Button colorScheme="yellow" size={"sm"}>
          Instructions
        </Button>
      </PopoverTrigger>
      <PopoverContent width={"600px"}>
        <PopoverArrow />
        <PopoverCloseButton />
        <PopoverBody>{children}</PopoverBody>
      </PopoverContent>
    </Popover>
  );
}
